import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsAdmin } from '../auth';

/**
 * Componente que protege las rutas administrativas de anuncios
 * Redirige silenciosamente al home si no tiene permisos
 */
export const AnnouncementsAdminGuard = ({ children }: {
  children: React.ReactNode;
}): JSX.Element | null => {
  const { isAdmin, loading } = useIsAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir silenciosamente al home si no es administrador
    if (!loading && !isAdmin) {
      navigate('/');
    }
  }, [isAdmin, loading, navigate]);

  // Mientras verifica permisos o si no es administrador, no mostrar nada
  if (loading || !isAdmin) {
    return null;
  }

  return <>{children}</>;
};
